import { CommonModule } from '@angular/common';
import { HttpClient, HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as FileSaver from 'file-saver';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { Subscription } from 'rxjs';
import { ModuleType } from 'src/app/common/model/moduleType';
import { SIBASI_SYSTEM_APP_MODULES } from 'src/app/common/model/sibasi-system.model';
import { IModule } from 'src/app/common/model/util.model';
import { FileService } from 'src/app/common/services/file/file.service';
import { UtilService } from 'src/app/common/services/util/util.service';
import * as XLSX from 'xlsx';

@Component({
  standalone: true,
  selector: 'app-file-import',
  templateUrl: './file-import.component.html',
  styleUrls: ['./file-import.component.scss'],
  imports: [ButtonModule, FileUploadModule, CommonModule]
})
export class FileImportComponent implements OnInit {
  subscriptions = new Subscription();
  uploadedFiles: any[] = [];
  progressInfos: any[] = [];
  message: string[] = [];
  @Input() moduleType: ModuleType = ModuleType.PROFILEPIC;
  @Input() uploadURL = '';
  type = '';
  @Output() passEntry = new EventEmitter<any>();
  moduleTypeEnum = ModuleType;
  uploaded = false;
  isLoaded = false;
  value = 0;

  constructor(
    private fileService: FileService,
    public utilService: UtilService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private http: HttpClient
  ) {}

  ngOnInit(): void {}

  selectFiles(event: any): void {
    this.message = [];
    this.progressInfos = [];
    this.uploadedFiles = event.currentFiles;
  }

  uploadFiles(): void {
    this.message = [];
    if (this.uploadedFiles) {
      for (let i = 0; i < this.uploadedFiles.length; i++) {
        this.upload(i, this.uploadedFiles[i]);
      }
    }
  }

  upload(idx: number, file: File): void {
    this.progressInfos[idx] = { value: 0, fileName: file.name };

    if (file) {
      const formData: FormData = new FormData();
      formData.append('file', file);

      const uploadModule: IModule = {
        moduleType: SIBASI_SYSTEM_APP_MODULES.USERPROFILEPICTURE,
        moduleItemId: this.uploadURL
      };

      this.fileService.uploadFile(formData, uploadModule).subscribe(
        (event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.progressInfos[idx].value = Math.round(
              (100 * event.loaded) / event.total
            );
          } else if (event instanceof HttpResponse) {
            const msg = 'Uploaded the file successfully: ' + file.name;
            this.message.push(msg);
            this.passEntry.emit(formData);
          }
        },
        (err: any) => {
          this.progressInfos[idx].value = 0;
          const msg = 'Could not upload the file: ' + file.name;
          this.message.push(msg);
        }
      );
    }
  }

  getExcelColumnTitles(file: File): Promise<string[]> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const range = XLSX.utils.decode_range(worksheet['!ref'] || '');
        const firstRow = range.s.r;

        const headers: string[] = [];
        for (let col = range.s.c; col <= range.e.c; ++col) {
          const cellAddress = { c: col, r: firstRow };
          const cellRef = XLSX.utils.encode_cell(cellAddress);
          const cell = worksheet[cellRef];
          const header = cell ? cell.v : `Column ${col + 1}`;
          headers.push(header);
        }

        resolve(headers);
      };
      reader.onerror = (error) => reject(error);
      reader.readAsArrayBuffer(file);
    });
  }

  readAsJson(): void {
    if (this.uploadedFiles) {
      for (let i = 0; i < this.uploadedFiles.length; i++) {
        this.fileService.readExcel(this.uploadedFiles[i]);
        this.isLoaded = true;

        const interval = setInterval(() => {
          this.value = this.value + Math.floor(Math.random() * 10) + 1;
          if (this.value >= 100) {
            this.value = 100;
            clearInterval(interval);
          }
        }, 70);
        setTimeout(() => {
          this.processUploadFile();
        }, 1000);
      }
    }
  }

  // processUploadFile(): any[] {
  //     const worksheet = this.fileService.readAsJson();

  //     if (worksheet && this.uploadedFiles.length > 0) {
  //         this.getExcelColumnTitles(this.uploadedFiles[0])
  //             .then((titles) => {
  //                 this.ref.close(worksheet);
  //                 // this.ref.close({ worksheet: worksheet, titles: titles });
  //             });

  //         for (let i = 0; i < worksheet.length; i++) {
  //             const item = worksheet[i];
  //         }

  //         return worksheet;
  //     } else {
  //         return [];
  //     }
  // }

  processUploadFile(): any[] {
    const worksheet = this.fileService.readAsJson();
    this.ref.close(worksheet);
    if (worksheet) {
      for (let i = 0; i < worksheet.length; i++) {
        const item = worksheet[i];
      }
      return worksheet;
    } else {
      return [];
    }
  }

  downloadSampleFile(): void {
    const sampleType = this.config.data;
    const url = 'assets/excel-samples/' + sampleType + '-sample.xlsx';
    this.http.get(url, { responseType: 'blob' }).subscribe((res: Blob) => {
      FileSaver.saveAs(res, sampleType + '.xlsx');
    });
  }
}
